<template>
	<v-dialog scrollable persistent v-model="dialog" @click:outside="closeDialog()" @keyup.esc="closeDialog()" :value="dialogVisible" max-width="400">
		<v-card>
			<v-card-title>
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="text-center font-14">
				{{ $vuetify.lang.t('$vuetify.views.wall.post.deletePostConfirm') }}
				<v-radio-group
					v-if="showAs"
					v-model="removeAs"
					row
				>
					<v-radio
						label="Usuń jako autor"
						value="author"
					></v-radio>
					<v-radio
						label="Usuń jako menadżer"
						value="manager"
					></v-radio>
				</v-radio-group>
			</v-card-text>
			<v-card-actions class="justify-content-center py-5 px-6">
				<v-btn @click="closeDialog()">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn @click="submit()" :loading="saving" color="accent">{{ $vuetify.lang.t('$vuetify.yes') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
	props: {
		post: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			saving: false,
			dialog: true,
			dialogVisible: true,
			removeAs: 'author'
		}
	},
	watch: {
		showAs(newVal) {
			this.removeAs = newVal;
		}
	},
	computed: {
		...mapGetters({
			user: 'auth/user'
		}),
		showAs() {
			if(this.user.role && this.user.role && this.user.role.role == 'manager') {
				return true;
			}
			return false;
		},
		finalModel() {
			let model = {
				id: this.post.id
			}
			if(this.showAs) {
				model.remove_as = this.removeAs;
			}
			return model;
		}
	},
	methods: {
		closeDialog() {
			this.$emit('closed');
		},
		async submit() {
			this.saving = true;
			const res = await this.$store.dispatch('wall/deletePost', this.finalModel)
			if(res.success) {
				this.closeDialog();
				this.$emit('deleted');
				this.$snackbar.success("Pomyślnie usunięto post")
			}
			else {
				this.$snackbar.error({error: res.error})
			}
			this.saving = false;
			
		}
	}
}
</script>